
import { useContext, useState } from "react";
import whySan from "../../assets/Why San-1.avif";
import drop from "../../assets/drop-1.svg";
import hoverDrop from "../../assets/hoverDrop-1.svg";
import { IoIosArrowDown } from "react-icons/io";
import { DContext } from "../../context/DataContext";

export default function WhySan() {
    const [openIndex, setOpenIndex] = useState(null);
    const { setOpenForm } = useContext(DContext)

    const dropDown = [
        {
            name: "Product First Thinking",
            content:
                "Every engagement is treated like a product, focused on long-term value and scale.",
        },
        {
            name: "Engineering With Precision",
            content:
                "Systems are built with performance, reliability, and security as fundamentals.",
        },
        {
            name: "Intelligence With Purpose",
            content:
                "AI and automation are applied deliberately to deliver measurable business outcomes.",
        },
        {
            name: "Systems Built To Scale",
            content:
                "Our platforms grow with business needs and evolving technology.",
        },
        {
            name: "Partnership Driven Delivery",
            content:
                "We work as an extension of your team, beyond simple execution.",
        },
        {
            name: "Ownership End To End",
            content:
                "We take responsibility across the entire lifecycle - from discovery to continuous evolution.",
        },
    ];

    return (
        <section className="py-8 md:py-10 bg-[#F4F5F6] px-4 sm:px-6 lg:px-24 ">
            <div className="mx-auto max-w-7xl">
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-6">

                    {/* LEFT */}
                    <div className="w-full lg:max-w-[550px]">
                        <h2 className="font-semibold  text-2xl md:text-3xl lg:text-4xl">
                            Why SAN Technovation
                        </h2>

                        <div className="my-10 px-2">
                            {dropDown.map((value, index) => {
                                const isOpen = openIndex === index;

                                return (
                                    <div
                                        onClick={() =>
                                            setOpenIndex(isOpen ? null : index)
                                        }
                                        key={index}
                                        className="bg-white p-4 sm:p-5 my-2 flex items-start gap-4 sm:gap-6 rounded-xl"
                                    >
                                        {/* Icon */}
                                        <div className="relative w-6 h-6 sm:w-[36px] sm:h-[36px] shrink-0">
                                            <img
                                                src={drop}
                                                alt=""
                                                className={`absolute inset-0 w-full h-full transition-opacity duration-500 ${isOpen ? "opacity-0" : "opacity-100"
                                                    }`}
                                            />
                                            <img
                                                src={hoverDrop}
                                                alt=""
                                                className={`absolute inset-0 w-full h-full transition-opacity duration-500 ${isOpen ? "opacity-100" : "opacity-0"
                                                    }`}
                                            />
                                        </div>

                                        {/* Text */}
                                        <div className="flex-1">
                                            <h6 className={`${isOpen ? 'text-secondary-500' : 'text-black'} font-medium text-base sm:text-xl lg:text-2xl`}>
                                                {value.name}
                                            </h6>

                                            <p
                                                className={`text-gray-600 text-sm sm:text-base transition-all duration-500 origin-top ${isOpen
                                                        ? "opacity-100 translate-y-0 mt-2 scale-y-100"
                                                        : "opacity-0 -translate-y-1 scale-y-95 h-0 overflow-hidden"
                                                    }`}
                                            >
                                                {value.content}
                                            </p>
                                        </div>

                                        {/* Arrow (touch friendly) */}
                                        <button
                                           
                                            className="p-2 -m-2"
                                        >
                                            <IoIosArrowDown
                                                className={`text-lg sm:text-xl  transition-transform duration-500 ${isOpen ? "rotate-180 text-secondary-500" : "rotate-0 text-black"
                                                    }`}
                                            />
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="w-full lg:max-w-[588px]">
                        <p className="font-secondary text-base sm:text-lg lg:text-xl font-medium">
                            What differentiates us is not just technology — but how we think,
                            build, and partner.
                        </p>

                        <div className="py-6 sm:py-7 relative">
                            <img alt="Why San" src={whySan} className="w-full h-auto" onContextMenu={(e) => e.preventDefault()}
                                draggable={false} />

                            <div className="absolute right-1 lg:right-[18px] sm:bottom-9 bottom-6">
                                <button
                                    onClick={() => setOpenForm(true)}  
                                    className="text-secondary-500 font-semibold text-[12px] sm:text-base py-2 sm:py-2.5 px-2 sm:px-6 bg-white rounded-lg border border-secondary-500 hover:bg-secondary-500 hover:text-white transition duration-700">
                                    Start Your Project
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
}

